import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from '@/store'
import 'lib-flexible'
import '@/mock/termsupdate'
import '@/utils/utils'
// 获取地址中search 色系Id 在全局配置对应的色系对象
import {getLocationSearch} from '@/utils/utils'
import styleConfig from '@/topicconfig'
// 国际化配置
import { IntlProvider } from '@/i18n'
// 组件中使用React.colorConfig.对置即可
if( Boolean(getLocationSearch().tenantTag) ){
  React.colorConfig = styleConfig[getLocationSearch().tenantTag]
}


ReactDOM.render(
  // <React.StrictMode>
    <Provider store={store}>
      <IntlProvider>
        <HashRouter>
          <App />
        </HashRouter>
      </IntlProvider>
    </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
